import { gql } from '@apollo/client';

export const CORE_ORGANIZATION_FIELDS = gql`
  fragment CoreOrganizationFields on Organization {
    id
    name
    organizationNumber
    type
    archived
    archivedAt
    createdAt
    createdFrom
    invitationLanguage {
      code
    }
    invoiceSendVia
    invoiceName
    invoiceEmail
    invoiceAddress
    invoiceZip
    invoiceCity
    invoicePeriod
    invoiceNote
    invoiceReference
    membersCount
    hidePriceList
    hubspotCompanyId
    hubspotSyncedId
  }
`;
